export default function sortByDate(a, b) {
  if (!a) {
    return -1;
  }
  if (!b) {
    return 1;
  }
  return new Date(a) - new Date(b);
}
